module.exports = __webpack_public_path__ + "img/document-not-found.a877b7b1.svg";